import { updateAGMsAPI } from "@services/agmsAPI";
import { getAgmWithCalcChainUsingSubchain, getElongPercents } from "../../helperFunctions/chainDistanceCalcs";
/**
       * 
       * @param {Object[]} subchains 
       * @description Recalculate Elongation Percents for AGMs after subchains have been updated
       */
export const recalculateElongValues = (subchains = [], agmRawData) => {
  try {
    let agmDataWithCalcChain = getAgmWithCalcChainUsingSubchain(agmRawData, subchains);
    let agmData = getElongPercents(agmDataWithCalcChain);
    updateAgms(agmData);
  } catch (error) {
    return error;
  }
}

/**
 * 
 * @param {Object[]} agmData 
 * @description API request to update Elong Percents in AGMs if the subchains have changed
 */
const updateAgms = async (agmData) => {
  let agmDataToUpdate = agmData.map((agm) => {
    const { AGMID, Elong_Percent } = agm;
    return { AGMID, Elong_Percent }
  })

  const response = await updateAGMsAPI(agmDataToUpdate);
  if (!response.success) {
    return new Error(response.message);
  }
}